import { styled } from '@material-ui/styles';
import { NavLink } from 'react-router-dom';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const StyledLink = styled(NavLink)(({ theme }: { theme: Theme }) => ({
    color: theme.palette.text.disabled,
    textDecoration: 'none'
}));
